import Vue from "vue";
import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";
import { ApiResponse } from "@/api/types";

const mutations: ExMutationTree<State, Mutations> = {
  getClipsSuccess(state, payload) {
    state.clips = payload.clips;
  },
  // NOTE リクエストが成功した場合でもStateは修正しない(リロード時のGETで読み込む)
  createClipSuccess(state, payload) {
    if (payload.clip.category === ApiResponse.CLIP_CATEGORIES.EXPERIENCE) {
      const i = state.clips.findIndex(
        e =>
          e.experience &&
          e.experience!.event_experience.id ===
            payload.clip.experience!.event_experience.id
      );
      // NOTE 普通に代入すると配列の変更を検知しないためSetを使用
      Vue.set(state.clips, i, payload.clip);
    } else {
      const i = state.clips.findIndex(
        e =>
          e.event_detail &&
          e.event_detail!.event_detail.id ===
            payload.clip.event_detail!.event_detail.id
      );
      // NOTE 普通に代入すると配列の変更を検知しないためSetを使用
      Vue.set(state.clips, i, payload.clip);
    }
  },
  deleteClipSuccess() {}
};

export default mutations;
